import { render, staticRenderFns } from "./ChangeEmailPopup.vue?vue&type=template&id=5fed8ff4"
import script from "./ChangeEmailPopup.vue?vue&type=script&lang=ts"
export * from "./ChangeEmailPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports